import { SignUpElement } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { SignUpSource } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import {
  useAssignSettingLoggedOutLightGate,
  useIsEligibleForLightGating,
  useIsLoggedOutLightGateTreatmentWithEligibility,
} from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutLightGate";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BottomDrawer } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/BottomDrawer";
import { trackSignupOpenModalClick } from "@faire/web-api--source/events/signup/click/openModal";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { cn } from "@faire/web/tools/cn";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { AppSignUpDrawer } from "../AppSignUp/AppSignUpDrawer";
import { useLightGatingStore } from "../AppSignUp/LightGatingContextStore";

const DRAWER_OPEN_DELAY = 500;

export const LoggedOutLightGatingDrawer: React.FC = () => {
  const isLightGateTreatment =
    useIsLoggedOutLightGateTreatmentWithEligibility();

  const {
    isDrawerVisible,
    isDrawerMinimized,
    setIsDrawerVisible,
    setIsDrawerMinimized,
    image,
  } = useLightGatingStore();

  const location = useLocation();
  const assignSettingLoggedOutLightGate = useAssignSettingLoggedOutLightGate();
  const isEligibleForLightGating = useIsEligibleForLightGating();

  useEffect(() => {
    if (isEligibleForLightGating) {
      assignSettingLoggedOutLightGate();
    }
  }, [isEligibleForLightGating, assignSettingLoggedOutLightGate]);

  useEffect(() => {
    if (isLightGateTreatment) {
      const timer = setTimeout(() => {
        setIsDrawerVisible(true);
        setIsDrawerMinimized(false);
        trackSignupOpenModalClick(
          image ? SignUpType.PRODUCT : SignUpType.AUTO,
          location.pathname + location.search,
          SignUpSource.LIGHT_GATE_BOTTOM_BANNER,
          image ? SignUpElement.PRODUCT_GRID : SignUpElement.AUTO_POPUP
        );
      }, DRAWER_OPEN_DELAY);

      return () => clearTimeout(timer);
    }
    return () => {};
  }, [
    isLightGateTreatment,
    location.pathname,
    setIsDrawerVisible,
    setIsDrawerMinimized,
  ]);

  useEffect(() => {
    if (isDrawerVisible && !isDrawerMinimized) {
      getWindowOrThrow().document.body.style.overflow = "hidden";
    } else {
      getWindowOrThrow().document.body.style.overflow = "auto";
    }
    return () => {
      getWindowOrThrow().document.body.style.overflow = "auto";
    };
  }, [isDrawerVisible, isDrawerMinimized]);

  if (!isLightGateTreatment) {
    return null;
  }

  return (
    <div data-test-id="logged-out-light-gating-drawer">
      {isDrawerVisible && !isDrawerMinimized ? (
        <div
          className={cn(
            "fixed inset-x-0 top-0 bottom-0 z-11",
            "from-core-surface-default/10 to-core-surface-default/80 bg-gradient-to-b"
          )}
        />
      ) : null}
      <BottomDrawer
        isOpen={isDrawerVisible}
        className={cn("z-11", isDrawerMinimized ? "" : "rounded-t-lg")}
      >
        <AppSignUpDrawer />
      </BottomDrawer>
    </div>
  );
};
